import { render, staticRenderFns } from "./Top-upDistribution.vue?vue&type=template&id=3fd238ae&scoped=true"
import script from "./Top-upDistribution.vue?vue&type=script&lang=js"
export * from "./Top-upDistribution.vue?vue&type=script&lang=js"
import style0 from "./Top-upDistribution.vue?vue&type=style&index=0&id=3fd238ae&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd238ae",
  null
  
)

export default component.exports